<script>
import deleteUserModal from "../../components/modals/modal-delete-user.vue";
import createUserSideBar from "../../components/settings/setting-create-user-sidebar.vue";

export default {
  name: "accountUsers",
  components: {
    deleteUserModal,
    createUserSideBar
  },
  methods: {
    editUser: function (user) {
      this.$refs.userEditor.edit(user);
    },
    deleteUser: function (user) {
      this.$refs.delUserModal.open(user, this.users);
    },
    CopyInviteUrlToClipBoard: async function (user) {
      let invite = this.pendingInvites[user.id];
      if (invite) {
        this.$A.CopyStringToClipboard(invite.inviteUrl);
        this.$A.AlertUser(
            invite.inviteUrl + " has been copied to your clipboard.",
            "success",
            10000
        );
      }
    },
    ResendUserInvite: function (user) {
      user && this.$A.UserService.UpdateUser(user.id)
      this.$A.AlertUser(
          "Invitation Expired",
          "success",
          10000
      );
    },
    updateUsers: async function (emitUpdate = true) {
      await this.loadPendingInvites();
      this.users = await this.$A.AccountService.All() || [];
      if (emitUpdate) this.$emit('updated');
    },
    loadPendingInvites: async function () {
      let pendingInvites = await this.$A.AccountService.GetAllPendingInvites() || [];
      let self = this;
      pendingInvites.forEach(function (invite) {
        self.pendingInvites[invite.userId] = invite;
      });
    },
    loadData: async function () {
      await this.loadPendingInvites();
      this.users = await this.$A.AccountService.All() || [];
      this.roles = await this.$A.RoleService.GetRoles() || [];
      this.teams = await this.$A.TeamService.GetAccountTeams() || [];

    },
    setRoles: function (roles) {
      this.roles = roles;
    },
    setTeams: function (teams) {
      this.teams = teams;
    }
  },
  data() {
    return {
      users: [],
      teams: [],
      roles: [],
      pendingInvites: {},
    };
  },
  computed: {
    canCreateMoreUsers: function () {
      const userLimit = _.get(this, '$A.Auth.account.subscriptionState.userLimit', 0);
      return !userLimit || this.users.length < userLimit;
    }
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Users</div>
      <div class="card-head-subtitle">Add and manage users on your account.</div>
    </div>

    <div class="user-rows">
      <div class="user-row" v-for="user in users" :key="user.id">
        <b-avatar :src="user.profileImageUrl" size="36px" class="user-avatar"/>
        <div class="user-main">
          <div class="user-name-line">
            <span class="user-name">{{ user.name }}</span>
            <span
                v-b-tooltip.hover
                title="Click to copy invite link"
                @click="CopyInviteUrlToClipBoard(user)"
                v-show="!user.emailVerified && pendingInvites[user.id]"
                class="invite-link invite-resend">Resend Invite</span>
            <span
                v-b-tooltip.hover
                title="Invitation Expired"
                @click="ResendUserInvite(user)"
                v-show="!user.emailVerified && !pendingInvites[user.id]"
                class="invite-link invite-expired">Invite Expired</span>
          </div>
          <div class="user-meta">
            <span v-if="user.title" class="user-title">{{ user.title }}</span>
            <span v-if="user.title && user.email" class="meta-dot">·</span>
            <span class="user-contact">{{ user.email }}</span>
            <span v-if="user.phone" class="meta-dot">·</span>
            <span v-if="user.phone" class="user-contact">{{ user.phone }}</span>
          </div>
        </div>
        <span class="role-chip">{{ user.permissions.roleName }}</span>
        <span class="row-actions">
          <a class="action-link" @click="editUser(user)">Edit</a>
          <a class="action-link action-danger" @click="deleteUser(user)">Delete</a>
        </span>
      </div>
    </div>

    <div class="card-foot">
      <a
          v-if="canCreateMoreUsers"
          v-b-toggle.create-user-sidebar
          class="primary-btn"
      >Add User</a>
      <button
          v-else
          class="locked-btn"
          @click="$A.BuyNow()"
          v-b-tooltip.hover="'Upgrade to add additional users'"
      >
        Feature Locked <img src="/img/feature-lock.svg" class="feature-icon ml-2"/>
      </button>
      <create-user-side-bar ref="userEditor" :available-teams="teams" :available-roles="roles" @saved="updateUsers"/>
    </div>
    <deleteUserModal ref="delUserModal" @deleted="loadData"/>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}

/* Rows */
.user-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  transition: background-color 120ms ease;
}
.user-row:hover {
  background: #f9f9fa;
}
.user-row:last-child {
  border-bottom: 0;
}
.user-avatar {
  flex-shrink: 0;
}
.user-main {
  flex: 1;
  min-width: 0;
}
.user-name-line {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.user-name {
  font-size: 13.5px;
  font-weight: 600;
  color: #111827;
}
.invite-link {
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.invite-resend {
  color: #019256;
  text-decoration: underline;
}
.invite-resend:hover {
  color: #017a48;
}
.invite-expired {
  color: #b43643;
}
.user-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 2px;
  font-size: 12.5px;
  color: #6b7280;
}
.meta-dot {
  color: #c2c8d0;
  font-weight: 600;
}
.role-chip {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 11px;
  font-weight: 600;
}
.row-actions {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
  min-width: 90px;
}
.action-link {
  font-size: 12.5px;
  font-weight: 600;
  color: #019256;
  cursor: pointer;
  text-decoration: none;
}
.action-link:hover {
  color: #017a48;
  text-decoration: none;
}
.action-danger {
  color: #b43643;
}
.action-danger:hover {
  color: #8f2a35;
}

/* Buttons */
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.locked-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: #F44271;
  border: 0;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
}
.locked-btn:hover {
  opacity: 0.9;
}
.feature-icon {
  height: 14px;
}

@media (max-width: 767px) {
  .user-row {
    flex-wrap: wrap;
    gap: 10px;
  }
  .user-main {
    flex-basis: calc(100% - 50px);
  }
  .role-chip {
    margin-left: 50px;
  }
  .row-actions {
    margin-left: auto;
    min-width: 0;
  }
  .primary-btn,
  .locked-btn {
    flex: 1;
  }
}
</style>
